import jscookie from 'js-cookie'
import { AUTH_API_COOKIE } from '../modules/user'

const state = {
	roomCollections: [],
	rcLoading: false,
}

const mutations = {
	setRoomCollections(state, payload) {
		state.roomCollections = payload
	},

	setRcLoading(state, payload) {
		state.rcLoading = payload
	},

	updateCollectionLastSave(state, payload) {
        const { collectionId, lastSave } = payload
        console.log("updateSave", payload)
        state.roomCollections.forEach(group => {
            const targetCollection = group.collections.find(
                collection => collection.collectionId === collectionId
            )

            if (targetCollection) {
                targetCollection.lastSave = lastSave
            }
        })
    },

}

const actions = {

	fetchRoomCollections ({commit, getters, rootState}) {
		let impersonateID = rootState.user.impersonate && rootState.user.impersonate.employeeID
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action: Fetching Room Collections  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/roomCollections', 
			{      
		      headers:  
		      	{ 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		        }, 
		  	})
		      .then(response => response.json())
		      .then(data => {
		      	commit('setRoomCollections', data)
		        resolve(data)
		      })
		})
	},

	fetchRoomCollectionsByUrl ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/roomCollections/share/'+ payload, 
			{      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      },
		      //method: "POST",
              //body: JSON.stringify(payload)
		  	})
		      .then(response => response.json())
		      .then(data => {
		      	commit('setRoomCollections', data)
		        resolve(data)
		      })
		})
	},

	rcMoveCollection ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/roomCollections/moveCollection',
			{      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      },
		      method: "POST",
              body: JSON.stringify(payload)
		  	})
		      .then(response => response.json())
		      .then(data => {
		        resolve(data)
		      })
		})
	},

	rcCloneGroup ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  rcCloneGroup")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/roomCollections/cloneGroup',
			{      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      },
		      method: "POST",
              body: JSON.stringify(payload)
		  	})
		      .then(response => response.json())
		      .then(data => {
		        resolve(data)
		      })
		})
	},

	rcAddGroup ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/roomCollections/addGroup',
			{      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      },
		      method: "POST",
              body: JSON.stringify(payload)
		  	})
		      .then(response => response.json())
		      .then(data => {
		        resolve(data)
		      })
		})
	},

	rcAddCollection ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/roomCollections/addCollection', 
			{      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      },
		      method: "POST",
              body: JSON.stringify(payload)
		  	})
		      .then(response => response.json())
		      .then(data => {
		        resolve(data)
		      })
		})
	},

	rcUpdateGroup({ commit, getters, dispatch }, payload) {
	    const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
	    commit('setRcLoading', true)
	    return new Promise((resolve, reject) => {
	        fetch('https://api.ba.arizona.edu/if/roomCollections/updateGroupV2', {
	            headers: {
	                'database': getters.getDatabase(),
	                'apiEsriToken': apiEsriToken,
	                'content-type': 'application/json',
	                'impersonate': getters.impersonateID
	            },
	            method: "POST",
	            body: JSON.stringify(payload)
	        })
	        .then(response => response.json())
	        .then(data => {
	            resolve(data)
	            if (data.includes('Stale')) {
	                commit('setSnackText', 'Someone else made changes. Refreshing. Try again.')
	            }
	            //return dispatch('fetchRoomCollections')
	            payload.lastSave = data.lastSave
	            commit('updateGroupLastSave', payload)
	        })
	        .then(() => {
	            commit('setRcLoading', false)
	        })
	        .catch(error => {
	            commit('setRcLoading', false)
	            reject(error)
	        })
	    })
	},

	rcUpdateCollection({ commit, getters, dispatch }, payload) {
    const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
    commit('setRcLoading', true)
    console.log("lastSave Before Save", payload.lastSave)
    return new Promise((resolve, reject) => {
        fetch('https://api.ba.arizona.edu/if/roomCollections/updateCollectionV2', {
            headers: {
                'database': getters.getDatabase(),
                'apiEsriToken': apiEsriToken,
                'content-type': 'application/json',
                'impersonate': getters.impersonateID
            },
            method: "POST",
            body: JSON.stringify(payload)
        })
        .then(response => response.json())
        .then(data => {            
            if (typeof data === 'string' && data.includes('Stale')) {
                commit('setSnackText', 'Some else made changes. Refreshing. Try again.')
                resolve(data)
                return dispatch('fetchRoomCollections')
            }
            //return dispatch('fetchRoomCollections')
            console.log("lastSave After Save", data.lastSave)
            commit('updateCollectionLastSave', { collectionId: payload.collectionId, lastSave: data.lastSave })
            resolve(data)
        })
        .then(() => {
            commit('setRcLoading', false)
        })
        .catch(error => {
            commit('setRcLoading', false)
            reject(error)
        })
    })
},


	rcDeleteCollection ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/roomCollections/deleteCollection', 
			{      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      },
		      method: "POST",
              body: JSON.stringify(payload)
		  	})
		      .then(response => response.json())
		      .then(data => {
		        resolve(data)
		      })
		})
	},

	rcDeleteGroup ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/roomCollections/deleteGroup', 
			{      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      },
		      method: "POST",
              body: JSON.stringify(payload)
		  	})
		      .then(response => response.json())
		      .then(data => {
		        resolve(data)
		      })
		})
	},
	
	rcUnsubscribeGroup ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/roomCollections/unsubscribeGroup', 
			{      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      },
		      method: "POST",
              body: JSON.stringify(payload)
		  	})
		      .then(response => response.json())
		      .then(data => {
		        resolve(data)
		      })
		})
	},

	rcUnsubscribeCollection ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/roomCollections/unsubscribeCollection', 
			{      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID,
		      },
		      method: "POST",
              body: JSON.stringify(payload)
		  	})
		      .then(response => response.json())
		      .then(data => {
		        resolve(data)
		      })
		})
	},

};

const getters = {
/*	getDept: state => () => {
		return state.room.pct[deptSelectedIndex];
	}*/
};

export default {
	state,
	getters,
	actions,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/roomCollections.js